import config from '../../../helpers/config.helper';

const appConfig = config();
export const baseURL = appConfig.REACT_APP_PUBLIC_URL;

const RoutesConstants = {
  Login: baseURL + '/login',
  Logout: baseURL +'/logout',
  User: baseURL + '/user',
  Sensor: baseURL + '/sensor',
  SensorData: baseURL + '/sensordata',
  IAQSensorData: baseURL + '/iaqsensordata',
  SensorDataChart: baseURL+ '/sensordatachart',
  IAQSensorDataChart: baseURL+ '/iaqsensordatachart',
  IAQRealTimeView: baseURL+ '/realtimeview',
  Download: baseURL+ '/download',
  IAQSensor: baseURL + '/iaqsensors',
};
export default RoutesConstants;